module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" style=\"height: 80vh\">\r\n    <div fxLayout=\"column\" fxLayoutAlign.lt-md=\"center center\">\r\n        <h1 class=\"text\">{{('Translate.Error' | translate).toUpperCase()}} 401</h1>\r\n        <h2 class=\"text\" [ngStyle.lt-md]=\"{'text-align': 'center'}\">{{'Message.NotAuthorized' | translate}}</h2>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pages/error/unauthorized-page.component.html
// module id = ./src/app/shared/pages/error/unauthorized-page.component.html
// module chunks = main